<template>
  <div>
    <div class="cf-turnstile-modal" v-show="isShowTurnstile">
    </div>
    <Modal :isNowrap="true" :show="showAuthModal" @close="closeModal" modalWrapClass="modal-bottom" modalClass="auth-modal authorization-modal wyrel-modal">
      <button type="button" class="close modal-button--close wyrel-close" @click="closeModal" v-once>
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 14 14" fill="none">
          <path d="M11.7067 0.278946C12.0786 -0.092982 12.6824 -0.092982 13.0543 0.278946C13.4259 0.650877 13.4261 1.2538 13.0543 1.62563L8.01332 6.66566L13.0543 11.7067C13.4263 12.0786 13.4263 12.6824 13.0543 13.0543C12.6824 13.4263 12.0786 13.4263 11.7067 13.0543L6.66566 8.01332L1.62563 13.0543C1.2538 13.4261 0.650877 13.4259 0.278946 13.0543C-0.092982 12.6824 -0.092982 12.0786 0.278946 11.7067L5.31898 6.66566L0.278946 1.62563C-0.092982 1.2537 -0.092982 0.650874 0.278946 0.278946C0.650874 -0.092982 1.2537 -0.092982 1.62563 0.278946L6.66566 5.31898L11.7067 0.278946Z" fill="#F6F6F6" fill-opacity="0.7"/>
        </svg>
      </button>
      <div class="authorization-modal__hero" v-if="!mobile">
        <img src="/img/site/login/modal-hero-wyrel.png?v=2" alt="Wyrel" onerror="this.src='/img/site/login/modal-hero-kfg.webp'">
        <img class="authorization-modal__hero-items" :class="{ visible: heroItemsVisible }" src="/img/site/login/hero-items.png?v=1" alt="">
      </div>
      <div class="authorization-modal__body" :style="{ height: containerHeight }">
        <div class="preloader-authorization" v-if="formLoader">
          <div class="wyrel-loader">
            <span></span><span></span><span></span><span></span>
          </div>
          <div class="text">{{ $t('Loggin in') }}</div>
          <div class="subtext">{{ $t('Please wait, while login processing') }}</div>
        </div>
        <template v-else>
          <transition
              name="fade-move"
              mode="out-in"
              @before-leave="beforeLeave"
              @before-enter="beforeEnter"
          >
            <div :key="type + '_' + isTwoFA + '_' + componentKey" class="authorization-modal__body-animate">
              <div class="authorization-modal__body-top">
                <h3 class="center" v-if="isTwoFA">{{ $t('Please verify your email') }}</h3>
                <h3 v-else-if="type === 'login' || type === 'social'">{{ $t('Log in to your account') }}</h3>
                <h3 v-else-if="type === 'signup'">{{ $t('Create your account') }}</h3>
                <h3 v-else-if="type === 'reset'">{{ $t('Please fill out required data') }}</h3>
                <h3 v-else-if="type === 'new-password'">{{ $t('Create your new passwod') }}</h3>
                <h3 class="center" v-else-if="type === 'password-changed'">{{ $t('Password changed') }}</h3>
                <p class="center" v-if="isTwoFA" v-html="$t('To verify your email address, please enter the verification code we sent to: {mail}', {mail: '<span>'+emailUser+'</span>'})"></p>
                <p v-else-if="type === 'login' || type === 'social'">{{ $t('Login to your account and join the world of games together') }}</p>
                <p v-else-if="type === 'signup'">{{ $t('Create your account and join the world of games together') }}</p>
                <p v-else-if="type === 'reset'">{{ $t('A code to reset password will be sent on your email.') }}</p>
                <p v-else-if="type === 'new-password'">{{ $t('Please create your new password for signing in.') }}</p>
                <p class="center" v-else-if="type === 'password-changed'">{{ $t('Password changed successfully, you can log in now.') }}</p>
              </div>
              <div class="authorization-modal__body-form" :key="componentKey">
                <component
                    :is="activeComponent"
                    v-bind="componentProps"
                />
              </div>
            </div>
          </transition>
        </template>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '/webpack-assets/vue/components/Modal.vue';
import Signup from '/webpack-assets/vue/templates/site/authorization/modal/Signup.vue';
import Login from '/webpack-assets/vue/templates/site/authorization/modal/Login.vue';
import TwoFA from '/webpack-assets/vue/templates/site/authorization/modal/TwoFA.vue';
import Reset from '/webpack-assets/vue/templates/site/authorization/modal/Reset.vue';
import Social from '/webpack-assets/vue/templates/site/authorization/modal/Social.vue';
import NewPassword from '/webpack-assets/vue/templates/site/authorization/modal/NewPassword.vue';
import PasswordChanged from '/webpack-assets/vue/templates/site/authorization/modal/PasswordChanged.vue';

export default {
  emits: ['update:showAuthModal', 'close-auth-modal'],
  props: {
    showAuthModal: {
      type: Boolean,
      required: false,
      default: false,
    },
    ifActivePayment: {
      type: Boolean,
      default: false,
    },
    authData: {
      type: Object,
    },
    isDifmark: {
      type: Boolean,
      default: true,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Modal,
    Signup,
    Login,
    TwoFA,
    Reset,
    Social,
    NewPassword,
    PasswordChanged
  },
  data() {
    return {
      type: 'social',
      isShowTurnstile: false,
      formLoader: false,
      emailUser: '',
      isTwoFA: false,
      twoFAType: '',
      twoFAttl: '',
      newPasswordToken: '',
      containerHeight: 'auto',
      blockHeight: 0,
      stepProgress: {
        all: 3,
        current: 1,
      },
      heroItemsVisible: false,
      heroItemsTimer: null,
    };
  },
  watch: {
    showAuthModal(val) {
      this.loadTurnstileScript();
      if(val) {
        clearTimeout(this.heroItemsTimer);
        this.heroItemsVisible = false;
        this.heroItemsTimer = setTimeout(() => {
          this.heroItemsVisible = true;
        }, 300);
      } else {
        clearTimeout(this.heroItemsTimer);
        this.heroItemsVisible = false;
        this.containerHeight = 'auto';
        this.blockHeight = 0;
        this.type = 'social';
        this.formLoader = false;
        this.isTwoFA = false;
        this.$emit('close-auth-modal');
      }
    },
    formLoader(val) {
      if (val) {
        this.containerHeight = '280px';
      } else {
        this.containerHeight = this.blockHeight + 'px';
      }
    }
  },
  methods: {
    closeModal() {
      this.type = 'social';
      this.formLoader = false;
      this.isTwoFA = false;
      this.containerHeight = 'auto';
      this.$emit('close-auth-modal');
    },
    handleTwoFA(payload) {
      this.formLoader = false;
      this.emailUser = payload.emailUser;
      this.isTwoFA = payload.status;
      this.twoFAType = payload.type;
      this.twoFAttl = payload.ttl;
      this.stepProgress = {
        all: payload.all,
        current: payload.current,
      }
      if(payload.isEmailVerified === 0){
        this.twoFAType = 'signup';
      } else if(this.twoFAType === 'login'){
      } else if(this.twoFAType === 'signup'){
      } else if (this.twoFAType === 'resetLogin'){
      } else if(this.twoFAType === 'resetUsername'){
      }
    },
    loadTurnstileScript() {
      const id = 'cf-turnstile-script';
      const old = document.getElementById(id);
      if (old) old.remove();
      if (window.turnstile) delete window.turnstile;

      return new Promise((resolve) => {
        const script = document.createElement('script');
        script.id = id;
        script.async = true;
        script.defer = true;
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        script.onload = () => {
          this.$nextTick(() => {
            const container = document.querySelector('.cf-turnstile-modal');
            if (window.turnstile && container) {
              container.innerHTML = '';
              window.turnstile.render(container, {
                sitekey: this.captchaToken,
                theme: 'light',
                callback: (token) => {
                  this.turnstileToken = token;
                }
              });
            }
          });
          resolve();
        };
        document.head.appendChild(script);
      });
    },
    captchaTokenFun(bool) {
      this.isShowTurnstile = bool;
      if(bool) {
        document.querySelector("body").classList.add("noscroll")
      } else {
        document.querySelector("body").classList.remove("noscroll")
      }
    },
    changeType(type) {
      this.type = type;
      this.formLoader = false;
      this.isTwoFA = false;
    },
    updateFormLoader(loaderState) {
      this.formLoader = loaderState;
    },
    handleNewPassword(payload) {
      this.type = 'new-password';
      this.formLoader = false;
      this.isTwoFA = false;
      this.newPasswordToken = payload.token;
    },
    handleSocialAuth(url) {
      const popupOptions = {
        resizable: 'yes',
        scrollbars: 'no',
        toolbar: 'no',
        menubar: 'no',
        location: 'no',
        directories: 'no',
        status: 'yes',
        width: 700,
        height: 800,
      };

      popupOptions.left = (window.screen.width - popupOptions.width) / 2;
      popupOptions.top = (window.screen.height - popupOptions.height) / 2;

      const popupFeature = Object.entries(popupOptions)
          .map(([key, val]) => `${key}=${val}`)
          .join(',');

      const authPopup = window.open(`${url}?view=modal`, 'yii_auth_choice', popupFeature);
      if (!authPopup) return;

      authPopup.focus();

      const intervalId = setInterval(() => {
        if (authPopup.closed) {
          clearInterval(intervalId);
          const redirectType = this.getCookie('popupWindowRedirect');
          const data = {
            csrf: this.getCookie('_csrf')
          };
          if (redirectType === 'signup') {
            window.tagTracking("registration");
          }

          if (redirectType) {
            //this.formLoader = true;
            this.successAuthorization(data);
          }
        }
      }, 100);
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    },
    beforeLeave(el) {
      if (!this.showAuthModal) return;
      if(this.mobile) {
        this.containerHeight = el.offsetHeight + 50 + 'px';
      } else {
        this.containerHeight = el.offsetHeight + 40 + 'px';
      }
    },
    beforeEnter(el) {
      if (!this.showAuthModal) return;
      this.$nextTick(() => {
        setTimeout(() => {
          if (!this.showAuthModal) {
            this.containerHeight = 'auto';
            return;
          }
          const offset = this.type !== 'social' && !this.mobile ? -20 : 0;
          const twoFAOffset = this.isTwoFA && !this.mobile ? 3 : 0;
          if(this.mobile) {
            this.containerHeight = el.offsetHeight + 50 + 'px';
            this.blockHeight = el.offsetHeight + 50
          } else {
            this.containerHeight = el.offsetHeight + 60 + offset + twoFAOffset + 'px';
            this.blockHeight = el.offsetHeight + 60 + offset + twoFAOffset
          }
        }, 0);
      });
    },
    changeHeightBlock (val) {
      if (this.containerHeight === this.blockHeight + val + 'px') return;
      this.containerHeight = this.blockHeight + val + 'px';
    },
    successAuthorization(data) {
      if(this.ifActivePayment && typeof window.successAuthorization === 'function') {
        console.log('[auth] CSRF from login response:', data.csrf);
        window.successAuthorization(data.csrf);
        this.$emit('close-auth-modal');
      } else {
        window.location.reload();
      }
    },
    preventRedirect() {
      this.redirect = false;
    },
  },
  computed: {
    availableMethods() {
      const methods = {
        facebook: null,
        google: null,
        twitch: null,
        yandex: null,
        microsoft: null,
        vkontakte: null,
        discord: null,
        steam: null,
        testgoogle: null,
      };

      if (Array.isArray(this.authData?.social_urls)) {
        this.authData?.social_urls.forEach(social => {
          if (methods[social.id] !== undefined) {
            methods[social.id] = social;
          }
        });
      }
      return methods;
    },
    captchaToken() {
      return this.authData?.cloudflare_token;
    },
    company_name() {
      return this.authData?.company_name;
    },
    settingsLang() {
      return this.authData?.language;
    },
    componentKey() {
      return this.isTwoFA ? 'twofa' : this.type;
    },
    activeComponent() {
      if (this.isTwoFA) return 'TwoFA';

      switch (this.type) {
        case 'social':
          return 'Social';
        case 'signup':
          return 'Signup';
        case 'login':
          return 'Login';
        case 'reset':
          return 'Reset';
        case 'new-password':
          return 'NewPassword';
        case 'password-changed':
          return 'PasswordChanged';
        default:
          return null;
      }
    },
    componentProps() {
      const baseProps = {
        authData: this.authData,
        onChangeType: this.changeType,
      };

      if (this.isTwoFA) {
        return {
          ...baseProps,
          onUpdateFormLoader: this.updateFormLoader,
          onNewPassword: this.handleNewPassword,
          onChangeHeightBlock: this.changeHeightBlock,
          onAuthSuccess: this.successAuthorization,
          twoFAType: this.twoFAType,
          twoFAttl: this.twoFAttl,
          stepProgress: this.stepProgress,
        };
      }

      switch (this.type) {
        case 'social':
          return {
            ...baseProps,
            socials: this.availableMethods,
            isDifmark: this.isDifmark,
            onUpdateCaptchaToken: this.loadTurnstileScript,
            onCaptchaToken: this.captchaTokenFun,
            onLinkSocial: this.handleSocialAuth,
            onAuthSuccess: this.successAuthorization,
          };
        case 'signup':
          return {
            ...baseProps,
            onUpdateCaptchaToken: this.loadTurnstileScript,
            onCaptchaToken: this.captchaTokenFun,
            onUpdateFormLoader: this.updateFormLoader,
            onUpdateIsTwoFa: this.handleTwoFA,
            onChangeHeightBlock: this.changeHeightBlock,
            onAuthSuccess: this.successAuthorization,
          };
        case 'login':
          return {
            ...baseProps,
            onUpdateCaptchaToken: this.loadTurnstileScript,
            onCaptchaToken: this.captchaTokenFun,
            onUpdateFormLoader: this.updateFormLoader,
            onChangeHeightBlock: this.changeHeightBlock,
            onUpdateIsTwoFa: this.handleTwoFA,
            onAuthSuccess: this.successAuthorization,
          };
        case 'reset':
          return {
            ...baseProps,
            socialGoogle: this.availableMethods.google,
            onLinkSocial: this.handleSocialAuth,
            onChangeHeightBlock: this.changeHeightBlock,
            onUpdateFormLoader: this.updateFormLoader,
            onUpdateIsTwoFa: this.handleTwoFA,
          };
        case 'new-password':
          return {
            ...baseProps,
            token: this.newPasswordToken,
            onChangeHeightBlock: this.changeHeightBlock,
            onUpdateFormLoader: this.updateFormLoader,
          };
        case 'password-changed':
          return {
            ...baseProps,
            onUpdateFormLoader: this.updateFormLoader,
          };
        default:
          return {};
      }
    },
  }
};
</script>

<style lang="scss">
@use "/webpack-assets/scss/pages/modals/auth";

.cf-turnstile-modal > div {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1101;
}
</style>

<style scoped lang="scss">
.fade-move-enter-active,
.fade-move-leave-active {
  transition: opacity 0.5s ease;
  position: absolute;
  left: 0;
  right: 0;
  width: auto;
}

.fade-move-enter-from,
.fade-move-leave-to {
  opacity: 0;
}

.fade-move-enter-to,
.fade-move-leave-from {
  opacity: 1;
}

.cf-turnstile-modal::before {
  content: '';
  position: fixed;
  left: 0;
  top: 0;
  backdrop-filter: blur(5px);
  background-color: rgba(17, 21, 26, .5);
  width: 100vw;
  height: 100vh;
  z-index: 1100;
  pointer-events: all;
}

.wyrel-close {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.20);
  position: absolute;
  top: -20px;
  right: -40px;
  z-index: 10;
  opacity: 1;
  transition: 0.3s all;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-top: 1px;
    margin-left: 1px;
    transition: all 0.3s ease;
    path {
      transition: all 0.3s ease;
    }
  }

  &:hover,
  &:focus {
    opacity: 1;
    color: inherit;
    filter: none;
    text-decoration: none;
    svg path {
      fill: #F6F6F6;
      fill-opacity: 1;
    }
  }

  @media (max-width: 767px) {
    top: 16px;
    right: 16px;
    background: transparent;

    svg {
      width: 15px;
      height: 15px;
    }

    svg path {
      fill: #9CA3AF;
      fill-opacity: 1;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }
}

.authorization-modal__hero {
  width: 100%;
  border-radius: 20px 20px 0 0;
  overflow: hidden;
  height: 230px;
  flex-shrink: 0;
  position: relative;

  > img:first-child {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  &-items {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 90%;
    height: auto;
    translate: -50% -50%;
    object-fit: contain;
    object-position: center;
    transform: scale(0);
    opacity: 0;
    transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.4s ease;
    pointer-events: none;

    &.visible {
      transform: scale(1);
      opacity: 1;
    }
  }
}

.wyrel-loader {
  display: flex;
  gap: 6px;
  justify-content: center;
  margin-bottom: 20px;
  height: 100px;
  align-items: center;

  span {
    width: 16px;
    height: 2px;
    border-radius: 1px;
    background: #F75A01;
    animation: wyrel-bounce 1.4s infinite ease-in-out both;

    &:nth-child(1) { animation-delay: -0.32s; }
    &:nth-child(2) { animation-delay: -0.16s; }
    &:nth-child(3) { animation-delay: 0s; }
    &:nth-child(4) { animation-delay: 0.16s; }
  }
}

@keyframes wyrel-bounce {
  0%, 80%, 100% { transform: scaleX(0.6); opacity: 0.4; }
  40% { transform: scaleX(1); opacity: 1; }
}
</style>